<nb-layout>
  <nb-layout-column>
    <nb-card>
      <nb-card-body [nbSpinner]="submitted" nbSpinnerStatus="info" nbSpinnerSize="xlarge"
        [nbSpinnerMessage]="'ALGEMEEN.EVEN_GEDULD' | translate">

        <div class="col-xl-4 col-lg-6 col-md-8 col-sm-12">
          <h3 class="title">{{ 'WACHTWOORD_INSTELLEN.TITEL' | translate }}</h3>
          <p class="form-text sub-title">{{ 'WACHTWOORD_INSTELLEN.HINT_TEKST' | translate }}
          </p>
          <form (ngSubmit)="reset()" #form="ngForm" autocomplete="nope">
            <div *ngIf="errors && errors.length > 0 && !submitted" class="alert alert-danger" role="alert">
              <div><strong>{{ 'WACHTWOORD_INSTELLEN.FOUTMELDING' | translate }}</strong></div>
              <div *ngFor="let error of errors">{{ error }}</div>
            </div>
            <div class="form-group">{{'WACHTWOORD_INSTELLEN.GEBRUIKERSNAAM' |
              translate}}
              <input name="username" [(ngModel)]="user.username" id="input-username" class="form-control"
                placeholder="gebruikersnaam" #username="ngModel"
                [class.form-control-danger]="username.invalid && username.touched" autofocus [required]="true">
              <small class="form-text error"
                *ngIf="username.invalid && username.touched && username.errors?.required">Gebruikersnaam is
                verplicht</small>
            </div>
            <div class="form-group">{{ 'WACHTWOORD_INSTELLEN.EMAILADRES' |
              translate }}
              <input name="email" [(ngModel)]="user.email" id="input-email" class="form-control" placeholder="email"
                #email="ngModel" [class.form-control-danger]="email.invalid && email.touched" autofocus
                [required]="true">
              <small class="form-text error" *ngIf="email.invalid && email.touched && email.errors?.required">{{
                'WACHTWOORD_INSTELLEN.MELDING.EMAILADRES_VERPLICHT' | translate }}</small>
            </div>
            <div class="form-group">{{'WACHTWOORD_INSTELLEN.NIEUW_WACHTWOORD' | translate}}
              <input name="newpassword" [(ngModel)]="user.password" type="password" id="input-newpassword"
                class="form-control" placeholder="wachtwoord" #password="ngModel"
                [class.form-control-danger]="password.invalid && password.touched" [required]="true">
              <small class="form-text error"
                *ngIf="password.invalid && password.touched && password.errors?.required">{{
                'WACHTWOORD_INSTELLEN.MELDING.WACHTWOORD_VERPLICHT' | translate }}</small>
            </div>
            <div class="form-group">{{ 'WACHTWOORD_INSTELLEN.HERHAAL_NIEUW_WACHTWOORD' | translate }}
              <input name="confirmpassword" [(ngModel)]="user.confirmpassword" type="password"
                id="input-confirmpassword" class="form-control" placeholder="herhaal wachtwoord"
                #confirmpassword="ngModel"
                [class.form-control-danger]="confirmpassword.invalid && confirmpassword.touched" [required]="true">
              <small class="form-text error"
                *ngIf="confirmpassword.invalid && confirmpassword.touched && confirmpassword.errors?.required">{{
                'WACHTWOORD_INSTELLEN.MELDING.HERHAAL_WACHTWOORD_VERPLICHT' | translate }}</small>
            </div>

            <br />
            <button [disabled]="submitted || !form.valid" class="btn btn-block btn-success"
              [class.btn-pulse]="submitted">{{ 'WACHTWOORD_INSTELLEN.BUTTON_INSTELLEN' | translate }}</button>
          </form>
        </div>
      </nb-card-body>
    </nb-card>
  </nb-layout-column>
</nb-layout>